/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';

// Providers
import permissionProviderReducer from './containers/common/PermissionProvider/reducer';
import snackbarProviderReducer from './containers/common/SnackbarProvider/ducks';
import userProviderReducer from './containers/common/UserProvider/ducks';
import { RESET_APP } from './utils/constants';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const appReducer = combineReducers({
    snackbarProvider: snackbarProviderReducer,
    userProvider: userProviderReducer,
    permissionProvider: permissionProviderReducer,
    ...injectedReducers,
  });

  // Wrap the root reducer and return a new root reducer with router state

  return (state, action) => {
    const prevState = state;

    if (action.type === RESET_APP) {
      const newState = {
        permissionProvider: state.permissionProvider,
      };

      return appReducer(newState, action);
    }

    return appReducer(prevState, action);
  };
}
